import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { browserHistory } from 'react-router';
import { Map } from 'immutable';
import { withTheme } from 'styled-components';

import Search from 'components/Search';
import BackButton from 'components/BackButton';
import globalMessages from 'components/globalMessages';
import { getGuestDirectorySearchData } from 'selectors/guestDirectory';
import { trackEvent } from 'utils/tracking';
import { StyledSearch, StyledSearchBar } from 'components/MenuSearch/styles';
import { SearchResultItem, SearchResultName, SearchResultContent, SearchResultType } from './styles';

interface Props {
  backButton?: Map<string, any>;
  theme?: any;
}

const GuestDirectorySearch: React.FC<Props> = ({ backButton, theme }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const searchData = useSelector(getGuestDirectorySearchData);

  const handleResultClick = (result, index) => {
    trackEvent('search', {
      search_term: searchTerm,
      category: 'guest_directory',
      item_type: result.type,
      item_id: result.id,
      item_name: result.name,
      position: index + 1,
    });

    browserHistory.push({
      pathname: result.url,
      state: { transition: 'Forward' },
    });
  };

  const renderResult = (result, index) => {
    let typeLabel;
    if (result.type === 'menu') {
      typeLabel = <FormattedMessage defaultMessage="Menu" />;
    } else if (result.type === 'section') {
      typeLabel = <FormattedMessage defaultMessage="Section" />;
    } else {
      typeLabel = <FormattedMessage defaultMessage="Content" />;
    }

    return (
      <SearchResultItem key={`${result.type}-${result.id}`} onClick={() => handleResultClick(result, index)}>
        <SearchResultName>{result.name}</SearchResultName>
        {result.content && (
          <SearchResultContent>
            {result.content.substring(0, 100)}
            {result.content.length > 100 ? '...' : ''}
          </SearchResultContent>
        )}
        <SearchResultType>{typeLabel}</SearchResultType>
      </SearchResultItem>
    );
  };

  return (
    <StyledSearch>
      <div className="u-flex u-flexAlignItemsCenter u-flexJustifyBetween container">
        {backButton && <BackButton fill={theme?.color?.iconFill} link={backButton.get('href')} />}
        <StyledSearchBar>
          <Search
            searchKeys={['name', 'content']}
            searchData={searchData}
            onFocus={() => {}}
            onBlur={() => {}}
            onClear={() => {}}
            onChange={searchTerm => setSearchTerm(searchTerm)}
            filtersActive={false}
            render={renderResult}
            placeholder={globalMessages.searchGuestDirectory}
          />
        </StyledSearchBar>
      </div>
    </StyledSearch>
  );
};

export default withTheme(GuestDirectorySearch);
